import React from "react";
import { Stack } from "../../../../Stacks/Stack/Stack";

export interface InternalListItemPersonaReflowProps {
    readonly personaGraphic: JSX.Element;
}

/*
 * Handles the alignment of the "reflow" experience of Persona in OneColumnListItem.
 *
 * We can't append the other first column children to the children of Persona, as Persona
 * has a specific height, which means that its overflow won't work.
 *
 * Additionally, there are some specific stylings that come with the "reflow" experience.
 */
export const InternalListItemPersonaReflow: React.FC<InternalListItemPersonaReflowProps> = ({ personaGraphic, children }) => (
    <Stack horizontal={true} padding="12px 0">
        {personaGraphic}
        <Stack horizontal={false}>{children}</Stack>
    </Stack>
);
